import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import PageTabing from '../../component/PageTabing';
import PageFilter from '../../component/PageFilter';
import { fetchConnectionSheetData } from '../../api/mappingApi';
import SheetTableLeft from './SheetTableLeft';
import SheetTableRight from './SheetTableRight';
import swal from 'sweetalert';
import SearchingFilter from '../../component/SearchingFilter';
import SearchBox from '../../component/SearchBox';
import { optionsLeft } from '../../constants';
import { optionsRight } from '../../constants';
import Loader from '../../component/Loader/Loader';

const Connections = () => {
 
  const [leftPage, setLeftPage]                           = React.useState(0);
  const [rightPage, setRightPage]                         = React.useState(0);
  const [leftRowsPerPage, setLeftRowsPerPage]             = React.useState(100);
  const [rightRowsPerPage, setRightRowsPerPage]           = React.useState(100);
  const [leftSheetMappingData, setLeftSheetMappingData]   = React.useState([]);
  const [rightSheetMappingData, setRightSheetMappingData] = React.useState([]);
  const [leftSheetFilter, setLeftSheetFilter]             = React.useState('');
  const [rightSheetFilter, setRightSheetFilter]           = React.useState('');
  const [selectedRowLeft, setSelectedRowLeft]             = React.useState(0);
  const [selectedRowRight, setSelectedRowRight]           = React.useState(0);
  const [searchByFilterLeft, setSearchByFilterLeft]       = React.useState('');
  const [searchLabelLeft, setSearchLabelLeft]             = React.useState('CTag / MBDTag');
  const [searchValueLeft, setSearchValueLeft]             = React.useState('');
  const [showSearchFormLeft, setShowSearchFormLeft]       = React.useState(false);
  const [searchByFilterRight, setSearchByFilterRight]     = React.useState('');
  const [searchLabelRight, setSearchLabelRight]           = React.useState('CTag / MBDTag');
  const [searchValueRight, setSearchValueRight]           = React.useState('');
  const [showSearchFormRight, setShowSearchFormRight]     = React.useState(false);
  const [showLoader, setShowLoader]                       = React.useState(false);
  const [tableParams, setTableParams]                     = React.useState({
    LParam:'',
    RParam:'',
    LParamDataType:'',
    RParamDataType:'',
  });

  const handleSelectRowLeft = (rowIndex,row) => {
    setSelectedRowLeft(rowIndex);
    setTableParams((prevState) => ({...prevState, LParam: row.Address, LParamDataType : row.DataType }))
  }

  const handleSelectRowRight = (rowIndex,row) => {
    setSelectedRowRight(rowIndex);
    setTableParams((prevState) => ({...prevState, RParam: row.Address, RParamDataType : row.DataType }))
  }
  
  React.useEffect(() => {
    if(leftSheetFilter !== ''){
      fetchData(leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft,searchValueLeft);
      window.addEventListener('storage',fetchData);
      return () => {
        window.removeEventListener('storage',fetchData);
      } 
    }
  },[leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft]);

  const fetchData = async (leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft,searchValueLeft) => {
    setShowLoader(true);
    const data = await fetchConnectionSheetData(leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft,searchValueLeft);
    setShowLoader(false);
    setLeftSheetMappingData(data);
  }

  const handleSearchLeft = async () => {
    if(searchValueLeft !== ''){
      if(leftPage > 0){
        setLeftPage(0); 
      } else {
        fetchData(leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft,searchValueLeft);
      }
    }
  }

  const handleClearSearchLeft = () => {
    setSearchValueLeft('');
    fetchData(leftPage,leftRowsPerPage,leftSheetFilter,searchByFilterLeft,'');
  }


  const handleSheetFilter = (e) => {
    setSelectedRowLeft(0);
    setLeftSheetFilter(e.target.value)
  }

  const handleChangePage = (event, pageVal) => {
    setSelectedRowLeft(0);
    setLeftPage(pageVal);
    //fetchData(pageVal,leftRowsPerPage);
  }

  const handleChangeRowsPerPage = (event) => {
    setSelectedRowLeft(0);
    const value = event.target.value === 'ALL' ? -1 : parseInt(event.target.value,10);
    setLeftRowsPerPage(value);
    setLeftPage(0);
    //fetchData(0,event.target.value);
  }

  React.useEffect(() => {
    if(rightSheetFilter !== ''){
      fetchRightTableData(rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight,searchValueRight);
    }
  },[rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight])

  const fetchRightTableData = async (rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight,searchValueRight) => {
    setShowLoader(true);
    const data = await fetchConnectionSheetData(rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight,searchValueRight);
    setShowLoader(false);
    setRightSheetMappingData(data);
  }

  const handleSearchRight = async () => {
    if(searchValueRight !== ''){
      if(rightPage > 0){
        setRightPage(0); 
      } else {
        fetchRightTableData(rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight,searchValueRight);
      }
    }
  }

  const handleClearSearchRight = () => {
    setSearchValueRight('');
    fetchRightTableData(rightPage,rightRowsPerPage,rightSheetFilter,searchByFilterRight,'');
  }


  const handleRightSheetFilter = (e) => {
    setSelectedRowRight(0);
    setRightSheetFilter(e.target.value)
  }

  const handleRightChangePage = (event, pageVal) => {
    setSelectedRowRight(0);
    setRightPage(pageVal);
    //fetchRightTableData(pageVal,rightRowsPerPage);
  }

  const handleRightChangeRowsPerPage = (event) => {
    const value = event.target.value === 'ALL' ? -1 : parseInt(event.target.value,10);
    setRightRowsPerPage(value);
    setRightPage(0);
    setSelectedRowRight(0);
   // fetchRightTableData(0,event.target.value);
  }

  const handleConnectTable = () => {
    if(tableParams.LParam !== '' && tableParams.RParam !== ''){
      if(tableParams?.LParamDataType !== tableParams?.RParamDataType){
        swal({
          title: "Oops",
          text: 'DataType of Addresses does not match. Connection can not be created.',
          icon: "error",
        })
        return;
      }
      let existingConnection = JSON.parse(localStorage.getItem('Connections'));
      if(existingConnection == null) existingConnection = [];
      if(existingConnection != null && existingConnection.length > 0){
        existingConnection =  existingConnection.filter(connect => connect.LParam !== tableParams.LParam);
      } 
      existingConnection.push({'LParam':tableParams.LParam,'RParam': tableParams.RParam});
      localStorage.setItem('Connections',JSON.stringify(existingConnection));
      setSelectedRowLeft(0);
      setSelectedRowRight(0);
      setTableParams({LParam:'',RParam:'',LParamDataType:'',RParamDataType:''});
      swal({
        title: "Success",
        text: 'Connection created successfully.',
        icon: "success",
      })
    }
  }

  const handleSearchByFilterLeft = (e) => {
    if(e.target.value === '1'){
      setSearchLabelLeft('CTag / MBDTag');
    } else {
      setSearchLabelLeft('English Text');
    }
    if(e.target.value !== ''){
      setSearchByFilterLeft(e.target.value);
      setShowSearchFormLeft(true);
    } else {
      setShowSearchFormLeft(false);
      setSearchByFilterLeft('');
      setSearchValueLeft('');
    }
  }

  const handleChangeTextValueLeft = (event) => {
    setSearchValueLeft(event.target.value);
  }

  const handleSearchByFilterRight = (e) => {
    if(e.target.value === '1'){
      setSearchLabelRight('CTag / MBDTag');
    } else {
      setSearchLabelRight('English Text');
    }
    if(e.target.value !== ''){
      setSearchByFilterRight(e.target.value);
      setShowSearchFormRight(true);
    } else {
      setShowSearchFormRight(false);
      setSearchByFilterRight('');
      setSearchValueRight('');
    }
  }

  const handleChangeTextValueRight = (event) => {
    setSearchValueRight(event.target.value);
  }

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Connections">
        <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
        Connections
        </Typography>
      </Breadcrumb>
      <PageTabing value="connection" />
      <Box component="section">
        <Grid className="contentBox">
          <Grid container direction="row" >
            <Grid item sm={12} xs={12} md={5}>
              <Grid container direction="row" spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <PageFilter 
                    options={optionsLeft}
                    //width={90}
                    filterValue={leftSheetFilter}
                    handleSheetFilter={handleSheetFilter} 
                  />
                </Grid>
                {leftSheetFilter !== '' &&
                  <Grid item xs={12} sm={6} md={4}>
                    <SearchingFilter 
                      //width={90}
                      value={searchByFilterLeft}
                      handleSearchByFilter={handleSearchByFilterLeft} 
                    />
                  </Grid>
                }
                {leftSheetFilter && showSearchFormLeft &&
                  <Grid item xs={12} sm={12} md={4}>
                    <SearchBox 
                      label={searchLabelLeft}
                      value={searchValueLeft}
                      handleChangeTextValue = {handleChangeTextValueLeft}
                      handleSearch={handleSearchLeft}
                      handleClearSearch={handleClearSearchLeft}
                    />
                  </Grid>
                }
              </Grid>
              {leftSheetFilter !== '' &&
                <SheetTableLeft 
                  page             = {leftPage} 
                  rowsPerPage      = {leftRowsPerPage}
                  selectedRowLeft  = {selectedRowLeft}
                  sheetMappingData = {leftSheetMappingData}
                  handleChangePage = {handleChangePage}
                  handleChangeRowsPerPage = {handleChangeRowsPerPage}
                  handleSelectRowLeft     = {handleSelectRowLeft}
                />
              }
            </Grid>
            <Grid item sm={12} xs={12} md={2}>
              <Stack
                justifyContent="center"
                gap={2}
                flexDirection="row"
                width={1.0}
                flexWrap="wrap"
                sx={{paddingTop: { xs: "20px" },paddingBottom: { xs: "20px" }}}
              > 
                {leftSheetFilter !== '' && rightSheetFilter !== '' &&
                  <Button 
                    variant='contained'
                    color='primary'
                    sx={{ top: { md: "350px"}}}
                    onClick={handleConnectTable}
                    size="small"
                  >
                    Connect
                  </Button>
                }
              </Stack>
            </Grid>
            <Grid item md={5} sm={12} xs={12}>
              <Grid container direction="row" spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <PageFilter 
                    options={optionsRight}
                    //width={90}
                    filterValue={rightSheetFilter}
                    handleSheetFilter={handleRightSheetFilter} 
                  />
                </Grid>
                {rightSheetFilter !== '' &&
                  <Grid item xs={12} sm={6} md={4}>
                    <SearchingFilter 
                      //width={90}
                      value={searchByFilterRight}
                      handleSearchByFilter={handleSearchByFilterRight} 
                    />
                  </Grid>
                }
                {rightSheetFilter && showSearchFormRight &&
                  <Grid item xs={12} sm={6} md={4}>
                    <SearchBox 
                      label={searchLabelRight}
                      value={searchValueRight}
                      handleChangeTextValue = {handleChangeTextValueRight}
                      handleSearch={handleSearchRight}
                      handleClearSearch={handleClearSearchRight}
                    />
                  </Grid>
                }
              </Grid>
              {rightSheetFilter !== '' &&
                <SheetTableRight 
                  page             = {rightPage} 
                  rowsPerPage      = {rightRowsPerPage}
                  selectedRowRight = {selectedRowRight}
                  sheetMappingData = {rightSheetMappingData}
                  handleChangePage = {handleRightChangePage}
                  handleChangeRowsPerPage = {handleRightChangeRowsPerPage}
                  handleSelectRowRight    = {handleSelectRowRight}
                />
              }
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};


export default Connections;
